import apolloClient from "../apolloClient";
import { GET_PRODUCT_COLLECTION } from "./graphql";

class ProductCollectionService {
	async all() {
		const response = await apolloClient.query({
			query: GET_PRODUCT_COLLECTION,
		});
		return response.data.collections.nodes;
	}
}

export default new ProductCollectionService();
